/* global require */
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('ion-rangeslider');
    require('@/../../vendor/yiisoft/yii2/assets/yii.activeForm.js')
} catch (e) {
  // no catch
}

require('slick-carousel');
